module.exports = __webpack_public_path__ + "static/media/gab_m2.3030f50a.webp";